'use strict';

/*global app*/
/*global services*/
/*global BasicProcess*/
/*global blockElement*/
/*global unBlockElement*/
/*global isEmpty*/
/*global ipsProcessed*/
/*global ipsNotReleased*/
/*global createObjectCallBack*/
/*global parseFloatK2*/
/*global sprintf*/
/*global resSuccess*/

function PickingProcess(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.kanbanLabelsPrinted = false;

  this.init();
}

PickingProcess.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'PickingProcess',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  onAfterInitKanban: function onAfterInitKanban() {
    var _this = this;

    if (!app.param('is_pematex')) {
      return _this;
    }

    //POKUD JE PEMATEX A KANBAN, TAK BY SE MELO TISKNOUT VYDY
    //ZEPTAM SE, ZDALI VYTISKNOUT ... POKUD ANO, VYTISKNU STITKY (NETISKNU POZDEJI), POKUD NE, NACTU TISKARNU A TISKNU ZE ZPRACOVANI POLOZEK

    var $items = _this.getPreparedItems();
    app.confirmHtml(sprintf(app.t('release_note.print_kanban_sn'), $items.length), function (ret) {
      if (ret) {
        //pokud chce vytisknout, vytiskneme
        app.printer.printKanbanLabels(_this.getWebDocumentRID());

        _this.kanbanLabelsPrinted = true;
      } else {
        //jinak se ptame na tiskarnu
        services.get('printer-setting').openPrinterSetting(function () {
          _this.focusFilterInput();
        });
      }

      _this.focusFilterInput();
    });

    return _this;
  },

  onAfterInit: function onAfterInit() {
    var _this = this;

    if (_this.getFormValue('IsKanban')) {
      return _this.onAfterInitKanban();
    }

    _this.printCustomerLabels();

    return _this;
  },

  onAfterAppendNewItemProcess: function onAfterAppendNewItemProcess($item, result, locationData, processItem) {
    var _this = this;

    if (processItem) {
      //dovydat polozku
      var $newItem = _this.cloneItem($item);

      _this.setItemValue($newItem, _this.settings.editedLocation, locationData.location);
      _this.setItemValue($newItem, _this.settings.editedLocation + 'Id', locationData.locationId);

      $newItem.find('.process-item__title--from-location').html(locationData.location);

      _this.changeItemFilterText($newItem, locationData.location);

      var data = _this.getItemData($item);

      _this.locationService.addUsedLocation(data);

      _this.changeItemProcessStatus($item, ipsProcessed);
    } else {
      _this.changeItemProcessStatus($item, ipsNotReleased);
    }

    _this.toggleItemsVisibility();
    _this.saveItems();

    _this.focusFilterInput();

    return _this;
  },

  onAfterAppendNewItem: function onAfterAppendNewItem($item, result) {
    var _this = this;

    var data = _this.getItemData($item);

    //pokud jsem neměl neshodu, tak nic nechci resit
    if (!data.Mismatch || data.Mismatch === '0') {
      return;
    }

    blockElement(_this.$form);
    _this.locationService.findLocation(data, function (res, resData) {
      unBlockElement(_this.$form);

      if (res === resSuccess) {
        if (resData.locationId !== 0) {
          services.get('confirm-service').confirm(app.t('picking_process.release_item_from_another_location'), function (ret) {
            _this.onAfterAppendNewItemProcess($item, result, resData, ret);
          });
        } else {
          services.get('output-service').showMessage(app.t('picking_process.item_can_not_be_released'), function () {
            _this.onAfterAppendNewItemProcess($item, result, resData, false);
          });
        }
      }
    });

    return _this;
  },

  getNumOfStickers: function getNumOfStickers($item, callback) {
    var _this = this;

    var maxNumOfStickers = 20;
    var boxType = _this.getItemValue($item, 'BoxType') + '/' + _this.getItemValue($item, 'BoxTypeDesc');
    var isRequiredInsertNumOfStickers = _this.getFormBoolValue('IsRequiredInsertNumOfStickers');
    if (!isRequiredInsertNumOfStickers) {
      return callback(1);
    }

    //dotazeme se na hodnotu
    app.getValue(sprintf(app.t('picking_process.num_stickers_help'), boxType, maxNumOfStickers), function (val) {
      val = parseFloatK2(val);
      if (val <= maxNumOfStickers) {
        return callback(val);
      }

      val = parseFloatK2(val);
      app.getValue(sprintf(app.t('picking_process.num_stickers_help'), boxType, maxNumOfStickers), function (val) {
        if (val <= maxNumOfStickers) {
          return callback(val);
        }

        app.showMessageHtml(sprintf(app.t('picking_process.incorect_num_of_stickers'), boxType, maxNumOfStickers), function () {
          callback(maxNumOfStickers);
        });
      });
    });

    return _this;
  },

  onAfterSaveProcessItemResult: function onAfterSaveProcessItemResult($item, result) {
    var _this = this;

    var serialNumber = _this.getItemValue($item, 'SerialNumber');
    var printSerialNumber = _this.getFormBoolValue('PrintCustomerSNFromProcessing');
    var isMultipick = _this.getFormValue('IsMultipick');
    var isKanban = _this.getFormValue('IsKanban');
    var webDocumentItemRID = _this.getItemValue($item, 'WebDocumentItemRID');
    var amount = _this.getItemFloatValue($item, 'Amount');

    if (!isEmpty(serialNumber) && !printSerialNumber && isMultipick && app.param('attach_customer_sn')) {
      //funkce zobrazuje zpravu, musime resit az tady, nesmime dale pokracovat, proto return
      services.get('output-service').showMessage(app.t('picking_process.attach_customer_serial_number'), function () {
        _this.checkZeroStockLevel($item, result);
      });

      return;
    }

    if (isKanban) {
      if (!_this.kanbanLabelsPrinted) {
        //vytiskneme stitky kanbanu - pokud je nevytiskl na zacatku

        var numOfItems = _this.getItemFloatValue($item, 'NumOfItems');
        var amountItems = _this.getItemFloatValue($item, 'AmountItems');
        if (amountItems > 0) {
          amount = amountItems;
        }

        _this.getNumOfStickers($item, function (numOfStickers) {
          app.printer.printKanbanLabel(webDocumentItemRID, amount, numOfStickers);

          if (numOfItems > 1) {
            app.showMessageHtml(sprintf(app.t('picking_process.item_from_more_locations'), numOfItems));
          }
        });
      }
    } else if (!isEmpty(serialNumber) && printSerialNumber) {
      //vytiskneme zakaznicky stitek
      app.printer.printCustomerLabel(webDocumentItemRID, amount);
    }

    //funkce zobrazuje zpravu, musime resit tady ...
    _this.checkZeroStockLevel($item, result);

    return _this;
  },

  onAfterSubmitForm: function onAfterSubmitForm() {
    var _this = this;

    var params = {
      callback: createObjectCallBack(_this, 'onAfterSubmitFormFinish'),
      webDocumentRID: _this.getWebDocumentRID(),
      area: app.param('active_area'),
      packingPlaceId: _this.getFormFloatValue('PackingPlaceId'),
      joiningSymbol: _this.getFormValue('JoiningSymbol'),
      handlingUnit: _this.getFormValue('HandlingUnit'),
    };

    blockElement(_this.$form);
    services.get('completion-service').mergeHandlingUnits(params);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
